const PRIMARY_SITE_URL = (import.meta.env.VITE_PRIMARY_SITE_URL || 'https://prosperityleaders.net').replace(/\/+$/, '')

export const DEFAULT_SEO = {
  baseUrl: PRIMARY_SITE_URL,
  title: 'Prosperity Leaders | Financial Independence Through Expert Guidance',
  description:
    'Prosperity Leaders equips individuals, families, and professionals with proven financial strategies that build lasting wealth and security.',
  image: 'https://media.publit.io/file/ProsperityWebApp/prosperity-og-imag.png',
  type: 'website',
  twitterCard: 'summary_large_image',
  siteName: 'Prosperity Leaders',
  robots: 'index,follow'
}

export default DEFAULT_SEO
